require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-what-lessons-from-indonesia-sustainable-least-cost.json") })
        }
      }, "path---en-us-project-what-lessons-from-indonesia-sustainable-least-cost");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-what-lessons-from-indonesia-sustainable-least-cost!./.cache/json/en-us-project-what-lessons-from-indonesia-sustainable-least-cost.json
// module id = 573
// module chunks = 231608221292675